import { MechanicalWarrantyComputeRequestDto } from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/ComputeMechanicalWarrantyRequestDto'
import { MechanicalWarrantyComputeResultDto } from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/ComputeMechanicalWarrantyResultDto'
import {
  MechanicalWarrantyWorksheet,
  MechanicalWarrantyWorksheetDto,
} from '@src/containers/EditWorksheet/EditMechanicalWarrantyWorksheetPage/types/mechanicalWarrantyWorksheetSchema'
import { makeCreate, makeGetSingleFromApi, makeUpdate } from '../make-api'
import { WorksheetDecision } from '@src/data/types'

const baseUrl = '/Applications/mechwarranty/'
const worksheetUrl = `${baseUrl}{creditApplicationId}/Worksheet`
const calculatorUrl = `${baseUrl}Calculator/Compute`
const mechanicalWarrantyWorksheetApi = {
  getById: makeGetSingleFromApi<MechanicalWarrantyWorksheet>(worksheetUrl),
  create: makeCreate<MechanicalWarrantyWorksheetDto, MechanicalWarrantyWorksheet>(worksheetUrl),
  update: makeUpdate<MechanicalWarrantyWorksheetDto, MechanicalWarrantyWorksheet>(worksheetUrl),
  computeMechanicalWarrantyLoan: makeCreate<MechanicalWarrantyComputeRequestDto, MechanicalWarrantyComputeResultDto>(
    calculatorUrl,
  ),
  updateDecision: makeUpdate<WorksheetDecision, MechanicalWarrantyWorksheet>(`${worksheetUrl}/Decision`),
}

export default mechanicalWarrantyWorksheetApi
